var _rect, _line, _line2, _line3, _line4, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add move function block") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 48,
    height: 48,
    fillOpacity: 0,
    stroke: "#000",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 40,
    x2: 14,
    y2: 40,
    stroke: "#000",
    strokeWidth: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 40,
    x2: 80,
    y2: 40,
    stroke: "#000",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    x2: 56,
    y1: 36,
    y2: 36,
    stroke: "black",
    strokeWidth: 5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    x2: 56,
    y1: 44,
    y2: 44,
    stroke: "black",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 32,
    r: 4,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 48,
    r: 4,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.d5abb041b353563b97c5429a897d9d56.svg";
export { ForwardRef as ReactComponent };